import type { Board } from '../../../../schema/coupon/entry.js';

/**
 * Selects and returns a boolean value indicating if every match is selected in a given coupon board.
 *
 * @param board Coupon board
 * @returns Boolean value indicating if every match is selected
 */
export function getEventCount(board: Board): [number, number] {
  const startedEventCount = board.outcomes.filter(
    (eventSelections) =>
      eventSelections.filter((eventSelection) => eventSelection.length).length === eventSelections.length
  ).length;
  const totalEventCount = board.outcomes.length;

  return [startedEventCount, totalEventCount] as const;
}
